import { atomFamily } from "recoil";

type NodeInputMessage = {
	key: string;
	default: string;
};

const initialNodeInputMessage: NodeInputMessage = {
	key: "nodeInput",
	default: "",
};

export const initialNodeInputMessageState = atomFamily(initialNodeInputMessage);
